import type { IconData } from '@stacksjs/iconify-core'

export const dk4x3: IconData = {
  "body": "<path fill=\"#c8102e\" d=\"M0 0h640.1v480H0z\"/><path fill=\"#fff\" d=\"M205.7 0h68.6v480h-68.6z\"/><path fill=\"#fff\" d=\"M0 205.7h640.1v68.6H0z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default dk4x3
